import React from "react";

export const LocalizationContext = React.createContext({});

export const LocalizationProvider = ({ children, pageContext }) => {
  const { locale, locales } = pageContext;
  const otherLocale = locales.find((l) => l !== locale);

  const isDefaultLocale = locale === locales[0];
  const localizePath = (path) => {
    if (path === "/") {
      return locale === locales[0] ? "/" : `/${locale}/`;
    }
    return `/${locale}/${path}`;
  };
  const switchPath = (path) => {
    const specialCases = {
      "/": `/${locales[1]}`,
      [`/${locales[1]}/`]: `/`,
      [`/${locales[1]}`]: `/`
    };
    return specialCases[path] || path.replace(locale, otherLocale);
  };

  const localization = {
    locale,
    locales,
    isDefaultLocale,
    localizePath,
    otherLocale,
    switchPath,
    direction: locale === "ar" ? "rtl" : "ltr"
  };

  return (
    <LocalizationContext.Provider value={localization}>
      {children}
    </LocalizationContext.Provider>
  );
};
